export default __webpack_public_path__ + "static/media/Carbasa Cingulum.59aa9622.jpg";